import React from "react";
import ReactDOM from "react-dom/client";
import "@/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const montar = () => root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Páginas públicas prerenderizadas (no la portada): se descarga su trozo antes de montar la app,
// así el HTML ya pintado se sustituye por el mismo contenido sin pasar por el «Cargando».
const prerenderizada = window.__SEO__ && window.location.pathname !== "/" && !document.documentElement.classList.contains("sin-prerender");
if (prerenderizada) import("@/publico/Publica").catch(() => {}).then(montar);
else montar();

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    // Descarga en segundo plano la pantalla de fichaje (va en un trozo aparte) para que el
    // service worker la guarde y el trabajador pueda abrirla después sin cobertura.
    if (navigator.onLine) {
      const precargar = () => import("@/pages/FichajeWorker").catch(() => {});
      if ("requestIdleCallback" in window) window.requestIdleCallback(precargar, { timeout: 5000 });
      else setTimeout(precargar, 3000);
    }
  });
}
